import { render, staticRenderFns } from "./AccueilSanteEnfant.vue?vue&type=template&id=ba07c66e&scoped=true&"
import script from "./AccueilSanteEnfant.vue?vue&type=script&lang=ts&"
export * from "./AccueilSanteEnfant.vue?vue&type=script&lang=ts&"
import style0 from "./AccueilSanteEnfant.vue?vue&type=style&index=0&id=ba07c66e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba07c66e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
